export interface AppConfig {
  supabaseUrl: string;
  supabaseAnonKey: string;
  apiBaseUrl: string;
}

interface PublicEnv {
  BUN_PUBLIC_SUPABASE_URL?: string;
  BUN_PUBLIC_SUPABASE_ANON_KEY?: string;
  BUN_PUBLIC_API_BASE_URL?: string;
}

function readPublicEnv(): PublicEnv {
  let supabaseUrl: string | undefined;
  let supabaseAnonKey: string | undefined;
  let apiBaseUrl: string | undefined;

  // O Bun substitui apenas variáveis definidas. Cada acesso fica isolado para
  // que uma variável opcional ausente não descarte as obrigatórias já injetadas.
  try { supabaseUrl = process.env.BUN_PUBLIC_SUPABASE_URL; } catch { /* browser sem variável injetada */ }
  try { supabaseAnonKey = process.env.BUN_PUBLIC_SUPABASE_ANON_KEY; } catch { /* browser sem variável injetada */ }
  try { apiBaseUrl = process.env.BUN_PUBLIC_API_BASE_URL; } catch { /* browser sem variável injetada */ }

  return {
    BUN_PUBLIC_SUPABASE_URL: supabaseUrl,
    BUN_PUBLIC_SUPABASE_ANON_KEY: supabaseAnonKey,
    BUN_PUBLIC_API_BASE_URL: apiBaseUrl,
  };
}

/**
 * Lê e valida as variáveis de ambiente do frontend.
 * Bun inlina referências literais `process.env.BUN_PUBLIC_*` no bundle client
 * (bunfig.toml `[serve.static] env`). O guard mantém um erro de configuração
 * legível quando uma variável não foi injetada, sem expor `process` no browser.
 */
export function getConfig(env: PublicEnv = readPublicEnv()): AppConfig {
  const supabaseUrl = env.BUN_PUBLIC_SUPABASE_URL;
  const supabaseAnonKey = env.BUN_PUBLIC_SUPABASE_ANON_KEY;
  if (!supabaseUrl) throw new Error("BUN_PUBLIC_SUPABASE_URL não foi definida no .env");
  if (!supabaseAnonKey) throw new Error("BUN_PUBLIC_SUPABASE_ANON_KEY não foi definida no .env");
  return {
    supabaseUrl,
    supabaseAnonKey,
    apiBaseUrl: env.BUN_PUBLIC_API_BASE_URL ?? "",
  };
}
